import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
// import { useHistory } from 'react-router-dom';
import ProgressFullscreen from '../components/common/ProgressFullscreen';
import useDish from '../features/DishContainer/hooks/useDish';
import useCreatePpsi from '../features/PpsiContainer/hooks/useCreatePpsi';
import usePpisRelatedToFormulaCode from '../features/PpiContainer/hooks/usePpisRelatedToFormulaCode';
// import useGlobalPpis from '../features/PpiContainer/hooks/useGlobalPpis';
import useUtensils from '../features/UtensilContainer/hooks/useUtensils';
import useQueryParams from '../utils/useQueryParams';
// import { getConfigs } from '../features/app/selectors';
import { getPpsiVariantData } from '../features/PpsiContainer/util';
// import { getIsGlobalUser } from '../features/loginSystem/selectors';
import PpsiForm from '../components/PpsiForm';
import { ppsiInProgressRoute, ppsiPublishedRoute } from '../routes';
import {
  getAvailableLanguages,
  getLanguage,
  getConfigs
} from '../features/app/selectors';
import { Mode } from '../components/PpsiForm/constants';
import View from './views';
// import usePpsi from '../features/PpsiContainer/hooks/usePpsi';
import useCreatePpsiFromGlobalNir from '../features/PpsiContainer/hooks/useCreatePpsiFromGlobalNir';
import {
  getvaraintPpsis,
  getIsFetchingVariant,
  getFetchvaraintError,
  getPpsiById
} from 'features/PpsiContainer/selectors';
// import { toJS } from 'utils/immutableUtils';
import {
  createPpsiVariant,
  fetchGlobalPpsi
} from 'features/PpsiContainer/actions';
import { toJS } from 'utils/immutableUtils';
import useGlobalPpis from 'features/PpiContainer/hooks/useGlobalPpis';
import useGlobalPublishedPpiIfs from 'features/PpsiContainer/hooks/useGlobalPublishedPpiIfs';
import { FranchiseType } from '../constants/franchiseType';
import useMarketDishLogo from 'features/PpsiContainer/hooks/useMarketDishLogo';
import useProductArea from 'features/DishContainer/hooks/useProductArea';

const PpsiCreateVariantView = () => {
  const [id, formulaCode, status] = useQueryParams(
    'id',
    'formulaCode',
    'status'
  );
  let actionType="variant"
  const [dish, isFetching] = useDish(formulaCode, actionType, { forceFetch: true });
  const [isFetchingPpisRelatedToFormula] = usePpisRelatedToFormulaCode(
    formulaCode
  );
  const [isFetchingLogo, marketDishLogo, fetchError] = useMarketDishLogo({
    forceFetch: true
  });
    const [isFetchingProductArea, productArea, fetchProductAreaError] = useProductArea({
    forceFetch: true
  });
  const dispatch = useDispatch();

  // const [isFetchingPpsi, ppsi, fetchPpsiError] = usePpsi(id, {
  //   forceFetch: true
  // });

  const [createPpsi, isSaving, createdPpsiId] = useCreatePpsi();
  const [
    createPpsiFromGlobal,
    isSavingNir,
    createdPpsiIdNir
  ] = useCreatePpsiFromGlobalNir();

  const languages = useSelector(getAvailableLanguages);
  const language = useSelector(getLanguage);
  const franchiseType = useSelector(getConfigs).toJS().franchise;
  const ppsi = useSelector(getvaraintPpsis);
  const fetchvaraintError = useSelector(getFetchvaraintError);
  const isFecthingVariant = useSelector(getIsFetchingVariant);
  const [glbalPpsiId, setGlobalPPsiId] = useState(null);
  const globalPpsi = useSelector(getPpsiById(glbalPpsiId));
  // const [isFetchingGlobalPpis, globalPpisRaw] = useGlobalPpis();
  // const globalPpis = toJS(globalPpisRaw, []);
  const [isFetchingGlobalPpiIfs, getGlobalId] = useGlobalPublishedPpiIfs();

  const reqStatus =
    status === 'GLOBAL REJECTED' || status === 'GLOBAL APPROVED'
      ? 'DRAFT'
      : status;

  useEffect(() => {
    dispatch(createPpsiVariant(id, reqStatus));
  }, []);

  // Initiate fetching of utensils
  useUtensils();
  // useGlobalPpis();
  const prevParentPpsiIdRef = useRef(null);
  useEffect(() => {
    // console.log(ppsi, 'ppsi');
    if (ppsi && ppsi.status === 'PUBLISHED') {
      if (ppsi && ppsi.publishedPpsiEnrichmentData) {
        const newParentPpsiId = ppsi.publishedPpsiEnrichmentData.parentPpsiId;
        if (
          newParentPpsiId &&
          newParentPpsiId !== prevParentPpsiIdRef.current
        ) {
          setGlobalPPsiId(newParentPpsiId);
          dispatch(fetchGlobalPpsi(newParentPpsiId));
          getGlobalId(newParentPpsiId);
          prevParentPpsiIdRef.current = newParentPpsiId;
        }
      }
    } else if (ppsi && ppsi.inProgressPpsiEnrichmentData) {
      const newParentPpsiId = ppsi.inProgressPpsiEnrichmentData.parentPpsiId;
      if (newParentPpsiId && newParentPpsiId !== prevParentPpsiIdRef.current) {
        setGlobalPPsiId(newParentPpsiId);
        dispatch(fetchGlobalPpsi(newParentPpsiId));
        getGlobalId(newParentPpsiId);
        prevParentPpsiIdRef.current = newParentPpsiId;
      }
    }
  }, [dispatch, ppsi]);

  const fromPpsi = toJS(globalPpsi);

  // Redirect, if created
  if (createdPpsiId || createdPpsiIdNir) {
    return (
      <Redirect to={ppsiInProgressRoute(createdPpsiId || createdPpsiIdNir)} />
    );
  }

  // Render spinner
  if (
    isFecthingVariant ||
    isSaving ||
    isSavingNir ||
    isFetching ||
    isFetchingPpisRelatedToFormula ||
    isFetchingGlobalPpiIfs ||
    isFetchingLogo
  ) {
    return <ProgressFullscreen open />;
  }

  if (fetchvaraintError) {
    if (reqStatus === 'DRAFT') {
      return <Redirect to={ppsiInProgressRoute(id)} />;
    }
    if (reqStatus === 'PUBLISHED' || reqStatus === 'UNPUBLISHED') {
      return <Redirect to={ppsiPublishedRoute(id)} />;
    }
  }

  function handleCreate(data, callback) {
    if (franchiseType !== FranchiseType.INGKA && data.dish.isGlobalBased) {
      createPpsiFromGlobal(data, callback, ppsi.piaArticleNumber);
    } else {
      createPpsi(data, callback);
    }
  }

  let getCopyData;

  if (
    status === 'DRAFT' ||
    status === 'GLOBAL REJECTED' ||
    status === 'GLOBAL APPROVED'
  ) {
    getCopyData = ppsi && ppsi.inProgressPpsiEnrichmentData;
  } else if (status === 'PUBLISHED' || status === 'UNPUBLISHED') {
    getCopyData = ppsi && ppsi.publishedPpsiEnrichmentData;
  }
console.log(getCopyData,"getCopyData")
  const { info } = getCopyData;
  const { parentPpsiEnrichmentDataId } = getCopyData;
  const { servingHoldingTemp } = getCopyData;
  const { servingHoldingTempUnit } = getCopyData;
  const { servingHoldingTime } = getCopyData;
  const { servingHoldingTimeUnit } = getCopyData;
  const { servingInstructions } = getCopyData;
  const { showHoldingInfoOnDishLevel } = getCopyData;
  const { ppiDetails } = getCopyData;
  const { mainImage } = getCopyData;
  const storeLists = getCopyData.storeCode;
  const salesAreas = getCopyData.salesPointCode;
  const { updateNotificationList } = getCopyData;
  const { dishLabel } = getCopyData;
  const { filterCode } = getCopyData
  const ingredientEntryList =getCopyData.referencedIFoodData.referencedIngredientEntities

  const defaultData = getPpsiVariantData(
    languages,
    dish,
    storeLists,
    salesAreas,
    mainImage,
    parentPpsiEnrichmentDataId,
    servingHoldingTemp,
    servingHoldingTempUnit,
    servingHoldingTime,
    servingHoldingTimeUnit,
    servingInstructions,
    showHoldingInfoOnDishLevel,
    ppiDetails,
    info,
    updateNotificationList,
    dishLabel,
    ingredientEntryList,
    status === 'PUBLISHED' ? filterCode : undefined
  );

  View.PpsiCreateVariant.visit(dish, language);
  return (
    <PpsiForm
      showProgress={isFecthingVariant}
      defaultData={defaultData}
      isSaving={isSaving}
      dataLabels={{
        title: `info.${language}.presentationName`
      }}
      mode={Mode.CREATE}
      onSave={handleCreate}
      globalData={fromPpsi}
      // globalPpsis={globalPpsis}
      // globalPpis={globalPpis}
    />
  );
};

export default PpsiCreateVariantView;
